import { Box, Tab } from "@compass/core";
import { Tabs } from "@mui/material";
import { useState } from "react";
import { ServiceDataProvider, useServiceData } from "../contexts";
import { ServiceChart } from "./ServiceChart";
import { DashboardCard } from "../components/DashboardCard";

const ServiceChartCardContent = () => {
    const { thisMonthRows, previousMonthRows, loading } = useServiceData();
    const [selectedPeriod, setSelectedPeriod] = useState<"thisMonth" | "previousMonth">("thisMonth");

    const handleTabChange = (_event: React.SyntheticEvent, newValue: "thisMonth" | "previousMonth") => {
        setSelectedPeriod(newValue);
    };

    const currentRows = selectedPeriod === "thisMonth" ? thisMonthRows : previousMonthRows;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Tabs value={selectedPeriod} onChange={handleTabChange} sx={{ mb: 2 }}>
                <Tab label="This Month" value="thisMonth" />
                <Tab label="Previous Month" value="previousMonth" />
            </Tabs>
            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <ServiceChart rows={currentRows} loading={loading} />
            </Box>
        </Box>
    );
};

export const ServiceChartCard = () => {
    return (
        <ServiceDataProvider>
            <DashboardCard title="Services">
                <ServiceChartCardContent />
            </DashboardCard>
        </ServiceDataProvider>
    );
};